export default __webpack_public_path__ + "247861e1b3e1ad9e962479f90879077f.png";